import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { USER_TIERS } from '../contexts/AuthContext';
import Admin from '../features/admin/Admin';
import AuthRedirect from '../shared/AuthRedirect';
import ProtectedRoute from '../shared/ProtectedRoute';

const AdminRouter = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute requiredTiers={[USER_TIERS.ADMIN]}>
            <Admin />
          </ProtectedRoute>
        }
      />
      {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
      <Route path="/signup" element={<AuthRedirect path="/signup" />} />
      <Route path="/profile" element={<AuthRedirect path="/profile" />} />
      <Route path="/login" element={<AuthRedirect path="/login" />} />
    </Routes>
  );
};

export default AdminRouter;
